import { api } from 'API/axios';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/MedicationsPdf';

export const getConfirmations = async (docId: string) => {
  const docData = await api.get(addImposterToUrl(baseUrl + `/${docId}`, true));
  if (docData.data) {
    return docData.data;
  }
};
